var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box"},[_c('img',{attrs:{"src":require('@/assets/image/home.png'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }